import React, { Component } from 'react';
import { Grid, Segment } from 'semantic-ui-react';
import ReteTutorService from 'shared/services/api/ReteTutor';
import { CardData } from '../../DashboardCommissioning/CardData';

class TutorResumesCards extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: true,
      inPreparation: null,
      confirmed: null,
      inProgress: null,
      notCompleted: null,
      operative: null,
    };
  }

  componentDidMount() {
    ReteTutorService.getTutorCardData().then((res) => {
      this.setState(res);
      this.setState({ isLoading: false });
    });
  }

  render() {
    return (
      <Segment loading={this.state.isLoading} basic>
        <Grid>
          <Grid.Row verticalAlign="middle" columns={5}>
            <Grid.Column>
              <CardData
                title={
                  <p>
                    IN PREPARAZIONE
                  </p>
                }
                total={this.state.inPreparation || '--'}
                color="royalBlue"
              />
            </Grid.Column>
            <Grid.Column>
              <CardData
                title={
                  <p>
                    INVIATI
                  </p>
                }
                total={this.state.confirmed || '--'}
                color="royalBlue"
              />
            </Grid.Column>
            <Grid.Column>
              <CardData
                title={
                  <p>
                    IN LAVORAZIONE
                  </p>
                }
                total={this.state.inProgress || '--'}
                color="royalBlue"
              />
            </Grid.Column>
            <Grid.Column>
              <CardData
                title={
                  <p>
                    NON PERFEZIONATI
                  </p>
                }
                total={this.state.notCompleted || '--'}
                color="royalBlue"
              />
            </Grid.Column>
            <Grid.Column>
              <CardData
                title={
                  <p>
                    OPERATIVI
                  </p>
                }
                total={this.state.operative || '--'}
                color="royalBlue"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default TutorResumesCards;



// WEBPACK FOOTER //
// ./app/components/TutorList/TutorResumesCards/index.js